import { Button, Modal } from 'react-bootstrap';
import React, { ReactNode } from 'react';
import Router from 'src/navigation/router';
import history from 'src/navigation/history';
import routes from 'src/navigation/routes';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { deleteSeance } from '../../store/actions/seance-actions';

interface Props {
    id: boolean | number | string;
    redirectId?: number;
    setData?: (pr: { open: boolean; RenderData: ReactNode }) => void;
    setModal: (type: boolean) => void;
}

const ModalDelete: React.FunctionComponent<Props> = ({ setModal, id, redirectId, setData }: Props) => {
    const dispatch = useDispatch();

    const handleClose = () => {
        setModal(false);
    };

    return (
        <Modal show={!!id} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ marginBottom: 0 }}>Are you sure you want to cancel this session?</p>
                <p style={{ marginBottom: 0 }}> Session will be permanently removed</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    No
                </Button>
                <Button
                    variant="danger"
                    onClick={() =>
                        dispatch(
                            deleteSeance(
                                `${id}`,
                                () => {
                                    handleClose();
                                    if (setData) {
                                        setData({
                                            open: false,
                                            RenderData: <div></div>,
                                        });
                                    }
                                    if (redirectId) {
                                        history.push(
                                            Router.generate(routes.PROVIDER_DETAIL, {
                                                tab: `calendar`,
                                                id: redirectId,
                                                subId: '',
                                            }),
                                        );
                                    }
                                },
                                (errorMessage: string) => {
                                    handleClose();
                                    toast.error(errorMessage);
                                },
                            ),
                        )
                    }
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDelete;
